<template>
  <div style="margin: 15px">
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="累计数据" name="first">
        <batchTotal ref="first" :listQuery="this.listQuery"></batchTotal>
      </el-tab-pane>

      <el-tab-pane label="专项附加扣除" name="second">
        <batchTotal ref="second" :listQuery="this.listQuery"></batchTotal>
      </el-tab-pane>
    <div class="topBtn">
      <div>
        <qzf-search-period v-model:period="listQuery.period" @success="getList"></qzf-search-period>
        <!-- <el-date-picker @change="getList" v-model="listQuery.period" type="month" value-format="YYYYMM" size="mini" placeholder="日期" style="width: 160px;margin-right:5px;"></el-date-picker> -->
        <el-input size="mini" placeholder="公司名称" v-model="listQuery.name" style="width:150px;margin-left:10px" @keyup.enter="getList"></el-input>
        <el-button size="mini" type="primary" @click="getList" style="margin-right:10px">搜索</el-button>
        <search @success="getList">
        </search>
      </div>
      <div>
        <el-button style="margin-left:10px;" v-if="listQuery.taskName == 'per-cj-leiji'" type="primary" size="mini" @click="handleljcsh()" plain>累计初始化</el-button>
        <el-button style="margin-left:10px;" v-if="listQuery.taskName == 'per-cj-zxfjkc'" type="primary" size="mini" @click="handleljcsh()" plain>专项扣除初始化</el-button>
        <!-- <qzf-button jz="false" button_code="yg_ss" class="filter-item">累计初始化</qzf-button> -->
        <!-- <qzf-button jz="false" button_code="yg_ss" class="filter-item" style="margin-left:10px;" v-if="listQuery.taskName == 'per-cj-zxfjkc'" type="primary" size="mini" @success="handlezxkc()" plain>专项扣除初始化</qzf-button> -->
        <el-dropdown @command="batchAll" style="margin-left:6px" size="mini">
          <qzf-button jz="false" button_code="xc_yg_gd" type="primary" size="mini">
            更多<i class="el-icon-arrow-down el-icon--right"></i>
          </qzf-button>
          <template #dropdown>
            <el-dropdown-menu style="text-align:center">
              <el-dropdown-item command="a">
                <span>一键配置法人</span>
              </el-dropdown-item>
              <el-dropdown-item command="b">
                <span>采集人员信息</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
          
        </el-dropdown>
      </div>
    </div>
    <el-table stripe :height="contentStyleObj" @selection-change="handleSelectionChange" size="mini" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%; margin-top: 10px;" :header-cell-style="{background: '#eee',color:'#333','font-size': '13px'}">
      <el-table-column type="selection" align="center" width="40"/>
      <el-table-column align="center" type="index" width="50" label="序号"> </el-table-column>
      <el-table-column label="初始账期" align="center" min-width="50">
        <template #default="{row}">
              <span>{{row.startAccountPeriod}}</span>
        </template>
      </el-table-column>
      <el-table-column label="公司名称" align="left" min-width="120">
          <template #default="{row}">
            <span v-if="row.type == '1'" class="xgmStyle">小</span>
            <span v-if="row.type == '2'" class="ybStyle">般</span>
            <!-- <el-button type="text">{{ row.name }}</el-button> -->
            <span>{{row.name}}</span>
          </template>
      </el-table-column>
      <el-table-column label="状态" align="center" min-width="100">
        <template #default="scope">
          <div class="item_icon">
            <i v-if="scope.row.taskStatus == 0" class="el-icon-warning"></i>
            <!-- <i v-if="scope.row.taskStatus == ''" class="el-icon-warning"></i> -->
            <i v-if="scope.row.taskStatus == 1" class="el-icon-warning"></i>
            <i v-if="scope.row.taskStatus == 2" class="el-icon-success"></i>
            <i v-if="scope.row.taskStatus == 3" class="el-icon-error"></i>
          </div>
          <span>
            <span v-if="scope.row.taskStatus == 0">未采集</span>
            <span v-if="scope.row.taskStatus == 1">采集中</span>
            <span v-if="scope.row.taskStatus == 2">采集完成</span>
            <span v-if="scope.row.taskStatus == 3">采集失败</span>
            
          </span>  
        </template>
      </el-table-column>
      <el-table-column label="初始时间" align="center" min-width="70">
        <template #default="{row}">
          <span>{{row.beginAt}}</span>
        </template>
      </el-table-column>
      <el-table-column label="专项扣除初始化" align="center" min-width="70" v-if="listQuery.taskName == 'per-cj-zxfjkc'">
        <template #default="{row}">
          <span>{{row.beginAt}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100">
        <template #default="scope">
          <el-button @click="checkDetail(scope.row)" size="mini" type="text">查看</el-button>
          <el-button @click="handleTaxTable(scope.row)" size="mini" type="text">重新初始化</el-button>
        </template>
      </el-table-column>
    </el-table>
    </el-tabs>
  </div>
</template>

<script>
import { companyInitTaxList } from '@/api/company.js'
import { currentAccountPeriod } from '@/utils'
import { sendTask } from "@/api/collection"
export default {
  name:'personalTax',
  data() {
    return {
      activeName: "first",
      listQuery:{
        period: currentAccountPeriod(),
        page:1,
        limit:20,
        taskName: 'per-cj-leiji',
        name:''
      },
      list: [],
      gsMainIds: undefined
    }
  },
  created() {
    this.contentStyleObj= this.$getHeight(280)
    this.getList()
    this.initBus()
  },
  methods: {
    initBus(){
      this.$bus.on("refreshTask", () => {
        //刷新业务
        let status = false
        this.list.forEach(res => {
          if(res.taskStatus == 1) {
            status = true
          }
        })
        if(status == true) {
          this.getList()
        }
      });
    },
    getList() {
      companyInitTaxList(this.listQuery).then(res => {
        this.list = res.data.data.list ? res.data.data.list : []
      })
    },
    handleClick() {
      if(this.activeName == "first"){
        this.listQuery.taskName = 'per-cj-leiji'
        this.getList()
      }else if (this.activeName == "second"){
        this.listQuery.taskName = 'per-cj-zxfjkc'
        this.getList()
      }
    },
    checkDetail(row){
      this.$store.dispatch('commons/setParam', {informationPeriod: row.startAccountPeriod,informationComId: row.comId})
      // this.$store.dispatch('tagsView/delCachedViewByName', "information")
      this.$router.push({
        path: "/initEa/initChushihua",
        // name: "information"
        name: "initChushihua"
      });
    },
    handleSelectionChange(row) {
      this.gsMainIds = []
      row.map(info=>{
        this.gsMainIds.push(info.comId)
      })
    },
    //重新采集税表
    handleTaxTable(row) {
      let param = {
        taskName: this.listQuery.taskName,
        period: this.listQuery.period,
        comIds: [row.comId],
      }
      sendTask(param).then(res => {
        if(res.data.msg == 'success') {
          this.$qzfMessage('已重新采集税表',3)
          this.getList()
        }
      })
    },
    //累计初始化
    handleljcsh() {
      if(!this.gsMainIds){
        this.$qzfMessage("请选择公司", 1)
        return
      }
      let param = {
        taskName: this.listQuery.taskName,
        period: this.listQuery.period,
        comIds: this.gsMainIds,
      }
      sendTask(param).then(res => {
        if(res.data.msg == 'success') {
          this.$qzfMessage('已累计初始化',3)
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.topBtn {
  display: flex;
  margin-bottom:10px;
  justify-content: space-between;
}
.item_icon{
  display: inline-block;
  width: 12%;
  // padding: 1px 3px;
  // padding-right: 10px;
  
  cursor: pointer;
  i{
    display: inline-block;
    line-height: 28px;
    font-size: 16px;
  }
  .el-icon-error{
    color: #f56c6c;
  }
  .el-icon-success{
    color: #67c23a;
  }
  .el-icon-circle-check{
    color: #67c23a;
  }
  .el-icon-info{
    color: #409eff
  }
  .el-icon-warning{
    color: #e6a23c;
  }
  .el-icon-warning-outline{
    color: #e6a23c;
  }
}
.el-table {
  /deep/ th {
    padding: 0px;
  }
  /deep/ td {
    padding: 0px;
  }
}
</style>